var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-year-selector"},[_c('span',{staticClass:"year-nav prev",on:{"click":_vm.selectPrevious}}),_c('span',{staticClass:"current-year"},[_vm._v(_vm._s(_vm.currentYear))]),_c('span',{staticClass:"year-nav next",on:{"click":_vm.selectNext}})])
}
var staticRenderFns = []

export { render, staticRenderFns }